class ProductTabs extends HTMLElement {
  constructor() {
    super();
    this.buttons = 
      this.querySelectorAll('.product-tabs__tab-button');
    this.contents = 
      this.querySelectorAll('.product-tabs__content');
  }

  connectedCallback() {
    this.buttons.forEach(button => {
      button.addEventListener('click', this.onTabClick.bind(this));
    });
  }

  onTabClick(event) {
    event.preventDefault();
    const target = event.currentTarget;
    const tabId = target.getAttribute('data-target');

    // Update buttons
    this.buttons.forEach(btn => 
      btn.setAttribute('aria-selected', 'false')
    );
    target.setAttribute('aria-selected', 'true');

    // Update content
    this.contents.forEach(content => {
      if (content.getAttribute('data-id') === tabId) {
        content.style.display = 'block';
        // Trigger reflow to restart animation/transition
        void content.offsetWidth; 
        content.setAttribute('aria-hidden', 'false');
      } else {
        content.setAttribute('aria-hidden', 'true');
        content.style.display = 'none';
      }
    });

    // Handle button display if separate buttons exist per tab content?
    // No, buttons are inside content usually or shared?
    // The requirement says "Button System... Each tab has its own button... Button is displayed below the products grid".
    // So the CTA button is inside the Tab Content container. That is handled automatically by hiding/showing content.
  }
}

customElements.define('product-tabs', ProductTabs);
